import { useMetaTags } from 'react-metatags-hook';
import { MetaTagsConfig } from 'react-metatags-hook/dist/cjs/types';
import sanitize from 'sanitize-html';
import { buildPublicUrl } from './buildUrl';
import { strEscape } from './strEscape';

const DEFAULT_TITLE = 'Ищите новые идеи от любимых брендов по картинкам — Яндекс Ритм';

const DEFAULT_EXTERNAL_TITLE = 'Яндекс Ритм';

const DEFAULT_DESCRIPTION = `Ритм позволяет следить за любимыми брендами или просто искать вдохновение — например, идеи для стиля или для ремонта в квартире.

Чтобы купить товар «как на картинке», больше не нужно искать в интернете — достаточно перейти по ссылке в посте. Находите идеи и товары по темам, которые вам интересны, от моды до спорта.`;

const sanitizeText = (text?: string) => (text ? strEscape(sanitize(text)) : undefined);

export const useMeta = (config: MetaTagsConfig = {}, dependencies: unknown[] = []) => {
    const sanitizedTitle = sanitizeText(config.title) || DEFAULT_TITLE;
    const sanitizedDescription = sanitizeText(config.description) || DEFAULT_DESCRIPTION;

    const openGraphConfig = config.openGraph || {};
    const sanitizedOpenGraphTitle = sanitizeText(openGraphConfig.title) || sanitizedTitle;
    const sanitizedOpenGraphDescription =
        sanitizeText(openGraphConfig.description) || sanitizedDescription;

    const twitterConfig = config.twitter || {};
    const sanitizedTwitterTitle = sanitizeText(twitterConfig.title) || sanitizedOpenGraphTitle;
    const sanitizedTwitterDescription =
        sanitizeText(twitterConfig.description) || sanitizedOpenGraphDescription;

    const metas = config.metas || [];

    return useMetaTags(
        {
            title: sanitizedTitle,
            description: sanitizedDescription,
            openGraph: {
                site_name: DEFAULT_EXTERNAL_TITLE,
                title: sanitizedOpenGraphTitle,
                image: openGraphConfig.image || buildPublicUrl('/images/og-image.png'),
                description: sanitizedOpenGraphDescription,
            },
            twitter: {
                card: 'summary_large_image',
                title: sanitizedTwitterTitle,
                description: sanitizedTwitterDescription,
                image:
                    twitterConfig.image ||
                    openGraphConfig.image ||
                    buildPublicUrl('/images/og-image.png'),
            },
            links: Array.isArray(config.links)
                ? config.links.map((link) => ({
                      ...link,
                      href: sanitizeText(link.href),
                  }))
                : [],
            metas,
        },
        dependencies,
    );
};
